import {
  GoalOverviewRoadmapViewOptions,
  RoadmapViewSettings,
  TimelineTimeframes,
} from '@griply/types';

import { stripUndefined } from '../utils/strip-undefined';

const coerceRoadmapView = (
  value: unknown,
): GoalOverviewRoadmapViewOptions | undefined =>
  Object.values(GoalOverviewRoadmapViewOptions).includes(
    value as GoalOverviewRoadmapViewOptions,
  )
    ? (value as GoalOverviewRoadmapViewOptions)
    : undefined;

const coerceTimeframe = (value: unknown): TimelineTimeframes | undefined =>
  Object.values(TimelineTimeframes).includes(value as TimelineTimeframes)
    ? (value as TimelineTimeframes)
    : undefined;

// forward-compat: a future client may write a roadmap view/timeframe this
// version doesn't know — coerce unknown enum values to undefined (the consumer
// falls back to its default) and a non-object roadmap to null. Shared by the
// goal and life-area converters.
export const coerceRoadmapViewSettings = (
  raw: unknown,
): RoadmapViewSettings | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const value = raw as Record<string, unknown>;
  // Stripped: consumers spread the coerced roadmap back into Firestore writes.
  return stripUndefined({
    webView: coerceRoadmapView(value.webView),
    mobileView: coerceRoadmapView(value.mobileView),
    webTimeframe: coerceTimeframe(value.webTimeframe),
    mobileTimeframe: coerceTimeframe(value.mobileTimeframe),
  });
};
